import { ApiClient } from './api'
import { LoginCredentials, RegisterCredentials, AuthResponse, User } from '../types'

export const AuthService = {
    // Token Management
    getTokens: () => {
        const accessToken = localStorage.getItem('accessToken')
        const refreshToken = localStorage.getItem('refreshToken')
        return { accessToken, refreshToken }
    },

    setTokens: (accessToken: string, refreshToken: string) => {
        localStorage.setItem('accessToken', accessToken)
        localStorage.setItem('refreshToken', refreshToken)
        localStorage.setItem('parallo-quoter-authenticated', 'true')
    },

    clearTokens: () => {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        localStorage.setItem('parallo-quoter-authenticated', 'false')
    },

    isAuthenticated: (): boolean => {
        const { accessToken, refreshToken } = AuthService.getTokens()
        return !!(accessToken && accessToken !== 'undefined' && refreshToken && refreshToken !== 'undefined')
    },

    // API Calls
    login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
        const response = await ApiClient.login(credentials)
        const { token: accessToken, refresh: refreshToken } = response.data

        if (accessToken && refreshToken) {
            AuthService.setTokens(accessToken, refreshToken)
        }

        return response
    },

    register: async (credentials: Omit<RegisterCredentials, 'confirmPassword'>): Promise<AuthResponse> => {
        const response = await ApiClient.register(credentials)
        const { token: accessToken, refresh: refreshToken } = response.data

        if (accessToken && refreshToken) {
            AuthService.setTokens(accessToken, refreshToken)
        }

        return response
    },

    logout: async (): Promise<void> => {
        try {
            await ApiClient.logout()
        } finally {
            AuthService.clearTokens()
        }
    },

    getCurrentUser: async (): Promise<User> => {
        const response = await ApiClient.getCurrentUser()
        return response.data
    },

    refreshToken: async (): Promise<{ accessToken: string; refreshToken: string }> => {
        const { refreshToken } = AuthService.getTokens()
        if (!refreshToken) {
            throw new Error('No refresh token available')
        }
        const response = await ApiClient.refreshToken(refreshToken)

        AuthService.setTokens(response.accessToken, response.refreshToken)

        return {
            accessToken: response.accessToken,
            refreshToken: response.refreshToken
        }
    }
}
